module.exports = __webpack_public_path__ + "static/media/congrats.e98615e6.PNG";